import React, { useEffect, useState } from "react";
import ReservaEditModal from "../../../components/ReservaLinks/ReservaEditModal";
import ReservaLinkForm from "../../../components/ReservaLinks/ReservaLinkForm";
import { useSession } from "../../../context/SessionContext";
import { useReservas } from "../../../hooks/useReservas";
import { t } from "../../../i18n";
import { Reserva, ReservaUpdatePayload } from "../../../types/reserva.types";
import { LinkedList } from "./LinkedList";

// Reservas vinculadas ao médico. Clicar no nome edita a reserva (vale para todos os médicos que a usam).
export const ReservaLinks: React.FC = () => {
  const { listMyReservas, updateReserva, unlinkReserva, updating, unlinking } = useReservas();
  const { setMetadata } = useSession();
  const [reservas, setReservas] = useState<Reserva[]>([]);
  const [loadingList, setLoadingList] = useState(true);
  const [reservaToEdit, setReservaToEdit] = useState<Reserva | null>(null);

  useEffect(() => {
    listMyReservas().then((result) => {
      if (result) setReservas(result.reservas);
      setLoadingList(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleConfirmEdit = async (payload: ReservaUpdatePayload) => {
    if (!reservaToEdit) return;
    const updated = await updateReserva(reservaToEdit.id, payload);
    // Erro já mostrado pelo useApi: o modal fica aberto para corrigir.
    if (!updated) return;
    setReservas((prev) => prev.map((r) => (r.id === updated.id ? updated : r)));
    setMetadata((prev) => ({ ...prev, reservas: prev.reservas.map((r) => (r.id === updated.id ? updated : r)) }));
    setReservaToEdit(null);
  };

  const handleUnlink = async (reserva: Reserva) => {
    if ((await unlinkReserva(reserva.id)) === null) return;
    setReservas((prev) => prev.filter((r) => r.id !== reserva.id));
    // Mantém `metadata.reservas` (lido por outras telas) igual ao que foi desvinculado aqui.
    setMetadata((prev) => ({ ...prev, reservas: prev.reservas.filter((r) => r.id !== reserva.id) }));
  };

  return (
    <div className="flex flex-col gap-3">
      {reservaToEdit && (
        <ReservaEditModal
          reserva={reservaToEdit}
          saving={updating}
          onConfirm={handleConfirmEdit}
          onClose={() => setReservaToEdit(null)}
        />
      )}
      <LinkedList
        items={reservas}
        loading={loadingList}
        loadingText={t("links.reserva.loading")}
        emptyText={t("links.reserva.empty")}
        unlinkTitle={t("links.reserva.unlinkTitle")}
        busy={unlinking}
        onUnlink={handleUnlink}
        addForm={
          <ReservaLinkForm
            existingReservas={reservas}
            onLinked={(reserva) => setReservas((prev) => (prev.some((r) => r.id === reserva.id) ? prev : [...prev, reserva]))}
          />
        }
        onEdit={setReservaToEdit}
      />
    </div>
  );
};
